export default __webpack_public_path__ + "static/media/andy.1dc6c19b.png";